import React from 'react';
import classNames from 'classnames';
import MediafileDetails from 'application/components/MediafileDetails';
import VideoMediafilePoster from 'application/components/VideoMediafileItemPoster';
import { getMediaPreviewKind } from 'application/utils/MediaPreviewUtils';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import Text from '@zvuk-b2b/react-uikit/ui/Text';

import styles from './index.module.scss';
import { TEXTS } from '../texts';
import { ELEMENT_IDS } from './consts';

import { VideoMediafilePreviewItemContentProps } from './types';

const VideoMediafilePreviewItemContent: React.FC<VideoMediafilePreviewItemContentProps> = ({
  isCompact,
  contentClassName,
  detailsClassName,
  titleClassName,
  descriptionClassName,
  popperClassName,
  title,
  duration,
  imgLink,
  uploading,
  actionText,
  actionHandler,
  extension,
  error,
  url,
  posterContainerClassName,
  posterClassName,
}) => {
  const descriptionText = uploading ? TEXTS.UPLOADING : undefined;
  const previewKind = getMediaPreviewKind({ extension });

  return (
    <div className={classNames(contentClassName ?? styles.content, { [styles.contentCompact]: isCompact })}>
      <div className={styles.poster}>
        <VideoMediafilePoster
          title={title}
          link={imgLink}
          uploading={uploading}
          duration={duration}
          extension={extension}
          url={url}
          isVideo={previewKind ? previewKind === 'video' : undefined}
          withPreview={Boolean(url) && !uploading && !error && previewKind !== undefined}
          containerClassName={posterContainerClassName}
          posterClassName={posterClassName}
        />
      </div>

      <MediafileDetails
        title={title}
        className={detailsClassName ?? styles.container}
        titleClassName={titleClassName ?? styles.title}
        popperClassName={popperClassName ?? styles.popper}>
        {descriptionText && <p className={descriptionClassName ?? styles.description}>{descriptionText}</p>}
        {actionText && (
          <Button
            className={styles.actionButton}
            elementId={ELEMENT_IDS.ACTION}
            type={ButtonType.PLAIN}
            onClick={actionHandler}>
            {actionText}
          </Button>
        )}

        {error && (
          <Text
            elementId={ELEMENT_IDS.ERROR}
            className={styles.error}>
            {TEXTS.ERROR}
          </Text>
        )}
      </MediafileDetails>
    </div>
  );
};

export default VideoMediafilePreviewItemContent;
